import { Box } from "@mui/material";
import { CoreButton, CoreModal } from "@verity/components/core";
import i18n from "../../../i18n";

const RefreshReportModal = (props: {
	instituteId: string | number;
	handleClose: () => void;
	onSubmit: () => void;
	verityFetch: typeof fetch;
	open?: boolean;
}) => {
	const handleRefresh = () => {
		void props.verityFetch(`/api/verity/report/admin/generate/${props.instituteId}`);
		props.handleClose();
		props.onSubmit();
	};

	return (
		<CoreModal
			open={props?.open ?? true}
			title={i18n.t("admin.components.institutionReportTSX.refreshTitle")}
			showBottomCloseButton={true}
			buttons={
				<CoreButton onClick={handleRefresh}>{i18n.t("admin.components.institutionReportTSX.refresh")}</CoreButton>
			}
			onClose={props.handleClose}
		>
			<Box alignContent={"center"} paddingX={"8px"}>
				{i18n.t("admin.components.institutionReportTSX.refreshDesc")}
			</Box>
		</CoreModal>
	);
};
export default RefreshReportModal;
